import { render, staticRenderFns } from "./MaterialLetters.vue?vue&type=template&id=573ed486"
import script from "./MaterialLetters.vue?vue&type=script&lang=js"
export * from "./MaterialLetters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports